
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
  getRuntime,
  skip
} = require('@prisma/client/runtime/index-browser.js')


const Prisma = {}

exports.Prisma = Prisma
exports.$Enums = {}

/**
 * Prisma Client JS version: 6.2.1
 * Query Engine version: 4123509d24aa4dede1e864b46351bf2790323b69
 */
Prisma.prismaVersion = {
  client: "6.2.1",
  engine: "4123509d24aa4dede1e864b46351bf2790323b69"
}

Prisma.PrismaClientKnownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientKnownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientUnknownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientRustPanicError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientRustPanicError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientInitializationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientInitializationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientValidationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientValidationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`sqltag is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.empty = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`empty is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.join = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`join is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.raw = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`raw is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.getExtensionContext is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.defineExtension = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.defineExtension is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}



/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.OrganizationScalarFieldEnum = {
  id: 'id',
  parent_org_id: 'parent_org_id',
  name: 'name',
  country: 'country',
  address: 'address',
  description: 'description',
  logo_url: 'logo_url',
  phone: 'phone',
  website: 'website',
  available_languages: 'available_languages',
  default_pref_id: 'default_pref_id',
  tracker_definition_id: 'tracker_definition_id',
  default_careplan_id: 'default_careplan_id'
};

exports.Prisma.TeamMemberScalarFieldEnum = {
  id: 'id',
  user_id: 'user_id',
  organization_id: 'organization_id',
  role: 'role',
  is_active: 'is_active',
  license: 'license',
  specialization: 'specialization',
  profession: 'profession',
  case_load: 'case_load',
  upload_terms: 'upload_terms'
};

exports.Prisma.PatientFileScalarFieldEnum = {
  id: 'id',
  uuid: 'uuid',
  user_id: 'user_id',
  organization_id: 'organization_id',
  is_active: 'is_active',
  treatment_start: 'treatment_start',
  treatment_end: 'treatment_end',
  healthcare_provider: 'healthcare_provider',
  ssn: 'ssn',
  medication: 'medication',
  notes: 'notes',
  treatment_end_reason: 'treatment_end_reason',
  primary_diagnosis_id: 'primary_diagnosis_id',
  tracker_definition_id: 'tracker_definition_id'
};

exports.Prisma.TagScalarFieldEnum = {
  id: 'id',
  name: 'name',
  organization_id: 'organization_id'
};

exports.Prisma.UserPreferencesScalarFieldEnum = {
  id: 'id',
  date_format: 'date_format',
  language: 'language',
  week_start: 'week_start',
  timezone: 'timezone',
  chat_active_hours: 'chat_active_hours',
  chat_automated_reply: 'chat_automated_reply',
  chat_mark_as_urgent_enable: 'chat_mark_as_urgent_enable',
  tracker_enabled: 'tracker_enabled'
};

exports.Prisma.UserScalarFieldEnum = {
  country: 'country',
  id: 'id',
  role: 'role',
  firebase_uid: 'firebase_uid',
  auth0_uid: 'auth0_uid',
  cognito_uid: 'cognito_uid',
  first_name: 'first_name',
  last_name: 'last_name',
  nickname: 'nickname',
  address: 'address',
  date_of_birth: 'date_of_birth',
  email: 'email',
  gender: 'gender',
  phone: 'phone',
  profile_image: 'profile_image',
  mobile_device_token: 'mobile_device_token',
  password_is_temp: 'password_is_temp',
  pref_id: 'pref_id',
  disabled: 'disabled',
  app_version: 'app_version',
  os_type: 'os_type',
  os_version: 'os_version',
  is_deleted: 'is_deleted',
  phone_otp: 'phone_otp',
  phone_otp_expires_at: 'phone_otp_expires_at'
};

exports.Prisma.AppLogScalarFieldEnum = {
  id: 'id',
  user_id: 'user_id',
  created_at: 'created_at',
  type: 'type',
  metadata: 'metadata'
};

exports.Prisma.ApprovedTermsScalarFieldEnum = {
  user_id: 'user_id',
  version: 'version',
  approve_time: 'approve_time'
};

exports.Prisma.PatientToFamilyUserScalarFieldEnum = {
  id: 'id',
  user_id: 'user_id',
  contact_user_id: 'contact_user_id',
  relation_type: 'relation_type',
  disabled: 'disabled'
};

exports.Prisma.CollaboratorScalarFieldEnum = {
  id: 'id',
  user_id: 'user_id',
  patient_id: 'patient_id',
  role: 'role',
  relation: 'relation'
};

exports.Prisma.CollaboratorPermissionScalarFieldEnum = {
  id: 'id',
  collaborator_id: 'collaborator_id',
  permission: 'permission',
  revoked_at: 'revoked_at'
};

exports.Prisma.QuestionScalarFieldEnum = {
  id: 'id',
  type: 'type',
  question: 'question',
  questionnaire_id: 'questionnaire_id',
  scale_id: 'scale_id',
  definition: 'definition',
  pos: 'pos',
  is_required: 'is_required',
  is_deleted: 'is_deleted',
  dependency_condition: 'dependency_condition'
};

exports.Prisma.QuestionnaireDefScalarFieldEnum = {
  id: 'id',
  language: 'language',
  created_at: 'created_at',
  created_by: 'created_by',
  title: 'title',
  friendly_name: 'friendly_name',
  organization_id: 'organization_id',
  description: 'description',
  long_description: 'long_description',
  professional_description: 'professional_description',
  is_published: 'is_published',
  is_public: 'is_public',
  is_active: 'is_active',
  img_id: 'img_id',
  recommended_recurrence: 'recommended_recurrence',
  is_deleted: 'is_deleted',
  color: 'color',
  min_age: 'min_age',
  max_age: 'max_age',
  target_role: 'target_role',
  instructions_url: 'instructions_url',
  printout_url: 'printout_url'
};

exports.Prisma.CarePlanProtocolAssignmentScalarFieldEnum = {
  id: 'id',
  created_by: 'created_by',
  patient_id: 'patient_id',
  protocol_id: 'protocol_id',
  status: 'status',
  assignment_date: 'assignment_date'
};

exports.Prisma.DiagnosisScalarFieldEnum = {
  id: 'id',
  name_en: 'name_en',
  order: 'order'
};

exports.Prisma.QuestionnaireDraftScalarFieldEnum = {
  id: 'id',
  created_by: 'created_by',
  created_at: 'created_at',
  edited_at: 'edited_at',
  is_deleted: 'is_deleted',
  state: 'state'
};

exports.Prisma.QuestionnaireScaleScalarFieldEnum = {
  id: 'id',
  direction: 'direction',
  questionnaire_id: 'questionnaire_id',
  calculation: 'calculation'
};

exports.Prisma.QuestionnaireScaleCutoffScalarFieldEnum = {
  id: 'id',
  scale_id: 'scale_id',
  name: 'name',
  min: 'min',
  color: 'color'
};

exports.Prisma.QuestionScaleScalarFieldEnum = {
  id: 'id',
  name: 'name',
  direction: 'direction',
  guideline: 'guideline',
  labels: 'labels',
  tooltip_labels: 'tooltip_labels',
  min: 'min',
  max: 'max',
  calculation: 'calculation',
  color: 'color'
};

exports.Prisma.QuestionScaleCutoffScalarFieldEnum = {
  id: 'id',
  scale_id: 'scale_id',
  name: 'name',
  min: 'min',
  color: 'color'
};

exports.Prisma.QuestionResponseScalarFieldEnum = {
  event_id: 'event_id',
  question_id: 'question_id',
  value: 'value'
};

exports.Prisma.QuestionGroupScoreScalarFieldEnum = {
  id: 'id',
  event_id: 'event_id',
  scale_id: 'scale_id',
  screening_instance_id: 'screening_instance_id',
  score: 'score',
  screening_question_scale_id: 'screening_question_scale_id'
};

exports.Prisma.QuestionAlertScalarFieldEnum = {
  id: 'id',
  question_id: 'question_id',
  from_score: 'from_score',
  alert_on: 'alert_on',
  message: 'message'
};

exports.Prisma.EventScalarFieldEnum = {
  id: 'id',
  care_plan_protocol_assignment_id: 'care_plan_protocol_assignment_id',
  care_protocol_element_id: 'care_protocol_element_id',
  unit_event_to_chapter_id: 'unit_event_to_chapter_id',
  unit_event_to_chapter_element_id: 'unit_event_to_chapter_element_id',
  patient_id: 'patient_id',
  type: 'type',
  collaborators: 'collaborators',
  description: 'description',
  created_at: 'created_at',
  created_by: 'created_by',
  status: 'status',
  completed_at: 'completed_at',
  expires_within: 'expires_within',
  discussion_point: 'discussion_point',
  assignee_id: 'assignee_id',
  goal_id: 'goal_id',
  earn_points: 'earn_points',
  is_timeless: 'is_timeless',
  is_absolute: 'is_absolute',
  is_conditioned: 'is_conditioned',
  date_on_timeline: 'date_on_timeline',
  generated_from: 'generated_from'
};

exports.Prisma.UnitEventsToChapterScalarFieldEnum = {
  id: 'id',
  unit_chapter_id: 'unit_chapter_id',
  parent_event_id: 'parent_event_id'
};

exports.Prisma.UnitEventScalarFieldEnum = {
  id: 'id',
  event_id: 'event_id',
  fill_started_at: 'fill_started_at',
  library_template_id: 'library_template_id'
};

exports.Prisma.EventRecurrenceScalarFieldEnum = {
  event_id: 'event_id',
  end: 'end',
  interval: 'interval',
  exclude: 'exclude',
  last_completed_at: 'last_completed_at',
  weekDays: 'weekDays'
};

exports.Prisma.EventCommentScalarFieldEnum = {
  id: 'id',
  event_id: 'event_id',
  text: 'text',
  tags: 'tags',
  created_at: 'created_at',
  created_by: 'created_by',
  updated_at: 'updated_at',
  history: 'history',
  status: 'status',
  date_on_timeline: 'date_on_timeline'
};

exports.Prisma.EventConditionScalarFieldEnum = {
  id: 'id',
  source_event_id: 'source_event_id',
  target_event_id: 'target_event_id',
  type: 'type',
  time_offset: 'time_offset',
  time_unit: 'time_unit',
  params: 'params',
  excluded_instances: 'excluded_instances',
  is_deleted: 'is_deleted'
};

exports.Prisma.TaskEventScalarFieldEnum = {
  id: 'id',
  event_id: 'event_id',
  task_id: 'task_id',
  title: 'title',
  status: 'status',
  duration: 'duration',
  is_timed: 'is_timed',
  end_time: 'end_time',
  finish_text: 'finish_text',
  attachment_id: 'attachment_id'
};

exports.Prisma.TaskDefScalarFieldEnum = {
  id: 'id',
  language: 'language',
  created_at: 'created_at',
  title: 'title',
  description: 'description',
  recommended_recurrence: 'recommended_recurrence',
  is_public: 'is_public',
  is_deleted: 'is_deleted',
  duration: 'duration',
  is_timed: 'is_timed',
  end_time: 'end_time',
  finish_text: 'finish_text',
  created_by: 'created_by',
  attachment_id: 'attachment_id'
};

exports.Prisma.QuestionnaireEventScalarFieldEnum = {
  id: 'id',
  event_id: 'event_id',
  questionnaire_id: 'questionnaire_id',
  fill_started_at: 'fill_started_at',
  score: 'score',
  reflection_response: 'reflection_response',
  reflection_thoughts_id: 'reflection_thoughts_id'
};

exports.Prisma.AppointmentEventScalarFieldEnum = {
  id: 'id',
  event_id: 'event_id',
  title: 'title',
  end_time: 'end_time',
  therapist_notes: 'therapist_notes',
  status: 'status',
  location: 'location',
  link: 'link'
};

exports.Prisma.MoodEventScalarFieldEnum = {
  id: 'id',
  event_id: 'event_id',
  status: 'status'
};

exports.Prisma.ReflectionThoughtsScalarFieldEnum = {
  id: 'id',
  text: 'text'
};

exports.Prisma.ExerciseEventScalarFieldEnum = {
  id: 'id',
  event_id: 'event_id',
  fill_started_at: 'fill_started_at',
  library_template_id: 'library_template_id'
};

exports.Prisma.EducationalContentEventScalarFieldEnum = {
  id: 'id',
  event_id: 'event_id',
  fill_started_at: 'fill_started_at',
  library_template_id: 'library_template_id'
};

exports.Prisma.PatientToJournalScalarFieldEnum = {
  id: 'id',
  patient_id: 'patient_id',
  exercise_id: 'exercise_id',
  user_id: 'user_id'
};

exports.Prisma.DiagnosesOnLibraryTemplateScalarFieldEnum = {
  library_template_id: 'library_template_id',
  diagnose_id: 'diagnose_id'
};

exports.Prisma.RolesOnLibraryTemplateScalarFieldEnum = {
  library_template_id: 'library_template_id',
  role_id: 'role_id'
};

exports.Prisma.LibraryTemplateScalarFieldEnum = {
  id: 'id',
  template_type: 'template_type',
  language: 'language',
  created_at: 'created_at',
  created_by: 'created_by',
  title: 'title',
  web_based_exercise: 'web_based_exercise',
  description: 'description',
  patient_title: 'patient_title',
  patient_description: 'patient_description',
  organization_id: 'organization_id',
  recommended_recurrence: 'recommended_recurrence',
  gender: 'gender',
  exercise_type: 'exercise_type',
  previous_instance: 'previous_instance',
  status: 'status',
  public_name: 'public_name',
  brief_summary: 'brief_summary',
  min_age: 'min_age',
  max_age: 'max_age'
};

exports.Prisma.EducationalContentScalarFieldEnum = {
  id: 'id',
  content_tree: 'content_tree',
  html: 'html',
  library_template_id: 'library_template_id'
};

exports.Prisma.RolesScalarFieldEnum = {
  id: 'id',
  role: 'role'
};

exports.Prisma.ExerciseQuestionScalarFieldEnum = {
  id: 'id',
  library_template_id: 'library_template_id',
  linkage_id: 'linkage_id',
  question: 'question',
  post_question: 'post_question',
  type: 'type',
  definition: 'definition',
  correct_answer: 'correct_answer',
  is_required: 'is_required',
  pos: 'pos',
  is_deleted: 'is_deleted'
};

exports.Prisma.ExerciseResponseScalarFieldEnum = {
  event_id: 'event_id',
  question_id: 'question_id',
  value: 'value',
  educationalContentEventId: 'educationalContentEventId'
};

exports.Prisma.TrackerEventScalarFieldEnum = {
  id: 'id',
  event_id: 'event_id',
  fill_started_at: 'fill_started_at'
};

exports.Prisma.TrackerQuestionScalarFieldEnum = {
  id: 'id',
  type: 'type',
  measure: 'measure',
  question: 'question',
  group: 'group',
  pos: 'pos',
  definition: 'definition',
  is_default: 'is_default',
  created_at: 'created_at',
  is_deleted: 'is_deleted',
  created_by: 'created_by',
  patient_id: 'patient_id',
  organization_id: 'organization_id'
};

exports.Prisma.TrackerDefinitionScalarFieldEnum = {
  id: 'id',
  patient_id: 'patient_id'
};

exports.Prisma.TrackerResponseScalarFieldEnum = {
  event_id: 'event_id',
  question_id: 'question_id',
  value: 'value'
};

exports.Prisma.TrackerQuestionLabelScalarFieldEnum = {
  id: 'id',
  question_id: 'question_id',
  label: 'label',
  is_default: 'is_default',
  is_deleted: 'is_deleted'
};

exports.Prisma.TrackerTranslationScalarFieldEnum = {
  id: 'id',
  type: 'type',
  key: 'key',
  language: 'language',
  value: 'value',
  organization_id: 'organization_id'
};

exports.Prisma.PortalNotificationScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  patient_id: 'patient_id',
  for_user_id: 'for_user_id',
  from_user_id: 'from_user_id',
  created_by: 'created_by',
  ref_data: 'ref_data',
  body: 'body',
  read: 'read',
  type: 'type',
  candidate_id: 'candidate_id'
};

exports.Prisma.MobileNotificationScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  created_on: 'created_on',
  scheduled_at: 'scheduled_at',
  sent_at: 'sent_at',
  interacted_at: 'interacted_at',
  user_id: 'user_id',
  topic: 'topic',
  type: 'type',
  title: 'title',
  body: 'body',
  data: 'data',
  read: 'read',
  status: 'status'
};

exports.Prisma.EmailNotificationScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  user_id: 'user_id',
  template: 'template'
};

exports.Prisma.PatientEngagementSnapshotScalarFieldEnum = {
  id: 'id',
  patient_id: 'patient_id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  state: 'state'
};

exports.Prisma.PatientEngagementMessageLevelScalarFieldEnum = {
  id: 'id',
  level: 'level',
  name: 'name',
  created_at: 'created_at',
  updated_at: 'updated_at'
};

exports.Prisma.PatientEngagementMessageScalarFieldEnum = {
  id: 'id',
  level_id: 'level_id',
  message_en: 'message_en',
  message_he: 'message_he',
  created_at: 'created_at',
  updated_at: 'updated_at'
};

exports.Prisma.PatientGoalScalarFieldEnum = {
  id: 'id',
  title: 'title',
  img_url: 'img_url',
  img_id: 'img_id',
  description: 'description',
  patient_id: 'patient_id',
  is_achieved: 'is_achieved',
  is_deleted: 'is_deleted'
};

exports.Prisma.PatientPointLogScalarFieldEnum = {
  id: 'id',
  goal_id: 'goal_id',
  type: 'type',
  patient_id: 'patient_id',
  created_at: 'created_at',
  points: 'points',
  ref_id: 'ref_id'
};

exports.Prisma.CarePlanScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  title: 'title',
  description: 'description',
  is_deleted: 'is_deleted',
  organization_id: 'organization_id'
};

exports.Prisma.QuestionnairesOnCarePlanScalarFieldEnum = {
  id: 'id',
  care_plan_id: 'care_plan_id',
  questionnaire_id: 'questionnaire_id',
  recommended_recurrence: 'recommended_recurrence',
  week_day: 'week_day',
  available_for: 'available_for'
};

exports.Prisma.CarePlanToLibraryTemplateScalarFieldEnum = {
  care_plan_id: 'care_plan_id',
  library_template_id: 'library_template_id',
  recommended_recurrence: 'recommended_recurrence',
  week_day: 'week_day',
  available_for: 'available_for'
};

exports.Prisma.CarePlanToTaskScalarFieldEnum = {
  care_plan_id: 'care_plan_id',
  task_id: 'task_id',
  recommended_recurrence: 'recommended_recurrence',
  week_day: 'week_day',
  available_for: 'available_for'
};

exports.Prisma.ChatPreferenceScalarFieldEnum = {
  id: 'id',
  sid: 'sid',
  type: 'type',
  configuration: 'configuration'
};

exports.Prisma.TaskAttachmentScalarFieldEnum = {
  id: 'id',
  key: 'key',
  entity: 'entity',
  original_name: 'original_name'
};

exports.Prisma.DisabledFeaturesScalarFieldEnum = {
  type: 'type',
  patient_id: 'patient_id'
};

exports.Prisma.DataMigrationsScalarFieldEnum = {
  migration_name: 'migration_name',
  started_at: 'started_at',
  finished_at: 'finished_at'
};

exports.Prisma.ScreeningTemplateScalarFieldEnum = {
  id: 'id',
  url_indentifier: 'url_indentifier',
  ui_language: 'ui_language',
  status: 'status',
  type: 'type',
  creator_id: 'creator_id',
  company_logo_url: 'company_logo_url',
  company_title: 'company_title',
  welcome_title: 'welcome_title',
  welcome_subtitle: 'welcome_subtitle',
  seo_title: 'seo_title',
  final_title: 'final_title',
  final_subtitle: 'final_subtitle',
  contact_phone_number: 'contact_phone_number',
  captca_info: 'captca_info',
  organization_id: 'organization_id'
};

exports.Prisma.ScreeningTemplateQuestionScalarFieldEnum = {
  id: 'id',
  screening_template_id: 'screening_template_id',
  questions_list_type: 'questions_list_type',
  position: 'position',
  is_required: 'is_required',
  is_deleted: 'is_deleted',
  scale_id: 'scale_id',
  type: 'type',
  question: 'question',
  definition: 'definition',
  column_name: 'column_name',
  description: 'description'
};

exports.Prisma.ScreeningGroupScoreScalarFieldEnum = {
  id: 'id',
  scale_id: 'scale_id',
  screening_answers_id: 'screening_answers_id',
  score: 'score',
  screening_instance_id: 'screening_instance_id'
};

exports.Prisma.ScreeningQuestionResponseScalarFieldEnum = {
  id: 'id',
  screening_answers_id: 'screening_answers_id',
  value: 'value',
  question_id: 'question_id'
};

exports.Prisma.ScreeningAnswerScalarFieldEnum = {
  id: 'id',
  screening_instance_id: 'screening_instance_id',
  screening_template_question_id: 'screening_template_question_id',
  value: 'value',
  questionnaire_id: 'questionnaire_id',
  fill_started_at: 'fill_started_at',
  score: 'score'
};

exports.Prisma.CandidateUserScalarFieldEnum = {
  id: 'id',
  uuid: 'uuid',
  organization_id: 'organization_id',
  screening_status: 'screening_status',
  accepted_patient_id: 'accepted_patient_id',
  case_manager_id: 'case_manager_id',
  collaborators: 'collaborators',
  is_phone_followup: 'is_phone_followup',
  is_email_sent: 'is_email_sent',
  summary: 'summary',
  rejection_stage: 'rejection_stage',
  rejector_user_id: 'rejector_user_id',
  rejection_reason: 'rejection_reason',
  rejection_reason_details: 'rejection_reason_details',
  created_time: 'created_time',
  updated_time: 'updated_time',
  email: 'email',
  phone: 'phone',
  first_name: 'first_name',
  last_name: 'last_name',
  gender: 'gender',
  date_of_birth: 'date_of_birth',
  address: 'address'
};

exports.Prisma.IntakeScalarFieldEnum = {
  id: 'id',
  candidate_user_id: 'candidate_user_id',
  summary: 'summary',
  intake_date: 'intake_date'
};

exports.Prisma.ScreeningInstanceScalarFieldEnum = {
  id: 'id',
  organization_id: 'organization_id',
  screening_template_id: 'screening_template_id',
  candidate_user_id: 'candidate_user_id',
  comments: 'comments',
  creation_time: 'creation_time',
  update_time: 'update_time'
};

exports.Prisma.ScreeningScaleScalarFieldEnum = {
  id: 'id',
  direction: 'direction',
  screening_template_id: 'screening_template_id',
  calculation: 'calculation'
};

exports.Prisma.ScreeningScaleCutoffScalarFieldEnum = {
  id: 'id',
  scale_id: 'scale_id',
  name: 'name',
  min: 'min',
  color: 'color'
};

exports.Prisma.ScreeningQuestionScaleScalarFieldEnum = {
  id: 'id',
  name: 'name',
  direction: 'direction',
  guideline: 'guideline',
  labels: 'labels',
  tooltip_labels: 'tooltip_labels',
  min: 'min',
  max: 'max',
  calculation: 'calculation',
  color: 'color'
};

exports.Prisma.ScreeningQuestionScaleCutoffScalarFieldEnum = {
  id: 'id',
  scale_id: 'scale_id',
  name: 'name',
  min: 'min',
  color: 'color'
};

exports.Prisma.UnitChapterScalarFieldEnum = {
  id: 'id',
  unit_library_template_id: 'unit_library_template_id',
  name: 'name',
  description: 'description',
  pos: 'pos',
  created_at: 'created_at',
  updated_at: 'updated_at',
  is_deleted: 'is_deleted'
};

exports.Prisma.UnitChapterElementScalarFieldEnum = {
  id: 'id',
  unit_chapter_id: 'unit_chapter_id',
  library_template_id: 'library_template_id',
  questionnaire_id: 'questionnaire_id',
  element_type: 'element_type',
  pos: 'pos',
  is_deleted: 'is_deleted',
  created_at: 'created_at',
  updated_at: 'updated_at'
};

exports.Prisma.MediaObjectScalarFieldEnum = {
  id: 'id',
  owner_object_type: 'owner_object_type',
  owner_object_id: 'owner_object_id',
  media_type: 'media_type',
  status: 'status',
  original_file_name: 'original_file_name',
  original_file_type: 'original_file_type',
  saved_file_name: 'saved_file_name',
  saved_file_path: 'saved_file_path',
  storage_provider: 'storage_provider',
  storage_provider_metadata: 'storage_provider_metadata',
  upload_result_string: 'upload_result_string',
  size: 'size',
  thumbnail_ref: 'thumbnail_ref',
  created_at: 'created_at',
  updated_at: 'updated_at',
  educational_content_id: 'educational_content_id'
};

exports.Prisma.CareProtocolElementScalarFieldEnum = {
  id: 'id',
  cp_library_template_id: 'cp_library_template_id',
  element_type: 'element_type',
  exercise_element_library_template_id: 'exercise_element_library_template_id',
  questionnaire_element_library_template_id: 'questionnaire_element_library_template_id',
  unit_element_library_template_id: 'unit_element_library_template_id',
  trigger_type: 'trigger_type',
  delay: 'delay',
  available_for: 'available_for',
  recurrence_interval: 'recurrence_interval',
  recurrence_end: 'recurrence_end',
  triggeringLogic: 'triggeringLogic',
  created_at: 'created_at',
  updated_at: 'updated_at',
  position: 'position',
  unit_completion_trigger_element_id: 'unit_completion_trigger_element_id',
  is_deleted: 'is_deleted'
};

exports.Prisma.CareProtocolSequentialEventsScalarFieldEnum = {
  id: 'id',
  care_protocol_element_id: 'care_protocol_element_id',
  event_id: 'event_id',
  status: 'status',
  trigger_type: 'trigger_type',
  patient_id: 'patient_id',
  protocol_id: 'protocol_id',
  creation_time: 'creation_time',
  update_time: 'update_time'
};

exports.Prisma.WebBasedEventScalarFieldEnum = {
  id: 'id',
  link_uuid: 'link_uuid',
  event_type: 'event_type',
  event_id: 'event_id',
  library_template_id: 'library_template_id',
  patient_id: 'patient_id',
  creation_time: 'creation_time',
  expiration_time: 'expiration_time',
  organization_id: 'organization_id'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.JsonNullValueInput = {
  JsonNull: Prisma.JsonNull
};

exports.Prisma.NullableJsonNullValueInput = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull
};

exports.Prisma.JsonNullValueFilter = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull,
  AnyNull: Prisma.AnyNull
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};

exports.Prisma.OrganizationOrderByRelevanceFieldEnum = {
  name: 'name',
  country: 'country',
  address: 'address',
  description: 'description',
  logo_url: 'logo_url',
  phone: 'phone',
  website: 'website'
};

exports.Prisma.TeamMemberOrderByRelevanceFieldEnum = {
  license: 'license'
};

exports.Prisma.PatientFileOrderByRelevanceFieldEnum = {
  uuid: 'uuid',
  healthcare_provider: 'healthcare_provider',
  medication: 'medication'
};

exports.Prisma.TagOrderByRelevanceFieldEnum = {
  name: 'name'
};

exports.Prisma.UserPreferencesOrderByRelevanceFieldEnum = {
  date_format: 'date_format',
  timezone: 'timezone',
  chat_automated_reply: 'chat_automated_reply'
};

exports.Prisma.UserOrderByRelevanceFieldEnum = {
  country: 'country',
  firebase_uid: 'firebase_uid',
  auth0_uid: 'auth0_uid',
  cognito_uid: 'cognito_uid',
  first_name: 'first_name',
  last_name: 'last_name',
  nickname: 'nickname',
  address: 'address',
  email: 'email',
  phone: 'phone',
  profile_image: 'profile_image',
  mobile_device_token: 'mobile_device_token',
  app_version: 'app_version',
  os_version: 'os_version',
  phone_otp: 'phone_otp'
};

exports.Prisma.AppLogOrderByRelevanceFieldEnum = {
  type: 'type'
};

exports.Prisma.ApprovedTermsOrderByRelevanceFieldEnum = {
  version: 'version'
};

exports.Prisma.CollaboratorOrderByRelevanceFieldEnum = {
  relation: 'relation'
};

exports.Prisma.QuestionOrderByRelevanceFieldEnum = {
  question: 'question',
  dependency_condition: 'dependency_condition'
};

exports.Prisma.QuestionnaireDefOrderByRelevanceFieldEnum = {
  title: 'title',
  friendly_name: 'friendly_name',
  description: 'description',
  long_description: 'long_description',
  color: 'color',
  instructions_url: 'instructions_url',
  printout_url: 'printout_url'
};

exports.Prisma.DiagnosisOrderByRelevanceFieldEnum = {
  name_en: 'name_en'
};

exports.Prisma.QuestionnaireScaleCutoffOrderByRelevanceFieldEnum = {
  name: 'name',
  color: 'color'
};

exports.Prisma.QuestionScaleOrderByRelevanceFieldEnum = {
  name: 'name',
  guideline: 'guideline',
  color: 'color'
};

exports.Prisma.QuestionScaleCutoffOrderByRelevanceFieldEnum = {
  name: 'name',
  color: 'color'
};

exports.Prisma.QuestionResponseOrderByRelevanceFieldEnum = {
  value: 'value'
};

exports.Prisma.QuestionAlertOrderByRelevanceFieldEnum = {
  message: 'message'
};

exports.Prisma.EventOrderByRelevanceFieldEnum = {
  description: 'description'
};

exports.Prisma.EventCommentOrderByRelevanceFieldEnum = {
  text: 'text'
};

exports.Prisma.EventConditionOrderByRelevanceFieldEnum = {
  type: 'type'
};

exports.Prisma.TaskEventOrderByRelevanceFieldEnum = {
  title: 'title',
  finish_text: 'finish_text'
};

exports.Prisma.TaskDefOrderByRelevanceFieldEnum = {
  title: 'title',
  description: 'description',
  finish_text: 'finish_text'
};

exports.Prisma.AppointmentEventOrderByRelevanceFieldEnum = {
  title: 'title',
  location: 'location',
  link: 'link'
};

exports.Prisma.ReflectionThoughtsOrderByRelevanceFieldEnum = {
  text: 'text'
};

exports.Prisma.LibraryTemplateOrderByRelevanceFieldEnum = {
  title: 'title',
  description: 'description',
  patient_title: 'patient_title',
  patient_description: 'patient_description',
  public_name: 'public_name',
  brief_summary: 'brief_summary'
};

exports.Prisma.EducationalContentOrderByRelevanceFieldEnum = {
  html: 'html'
};

exports.Prisma.RolesOrderByRelevanceFieldEnum = {
  role: 'role'
};

exports.Prisma.ExerciseQuestionOrderByRelevanceFieldEnum = {
  question: 'question',
  post_question: 'post_question'
};

exports.Prisma.ExerciseResponseOrderByRelevanceFieldEnum = {
  value: 'value'
};

exports.Prisma.TrackerQuestionOrderByRelevanceFieldEnum = {
  measure: 'measure',
  question: 'question',
  group: 'group'
};

exports.Prisma.TrackerQuestionLabelOrderByRelevanceFieldEnum = {
  label: 'label'
};

exports.Prisma.TrackerTranslationOrderByRelevanceFieldEnum = {
  key: 'key',
  value: 'value'
};

exports.Prisma.PortalNotificationOrderByRelevanceFieldEnum = {
  body: 'body',
  type: 'type'
};

exports.Prisma.MobileNotificationOrderByRelevanceFieldEnum = {
  topic: 'topic',
  type: 'type',
  title: 'title',
  body: 'body'
};

exports.Prisma.EmailNotificationOrderByRelevanceFieldEnum = {
  template: 'template'
};

exports.Prisma.PatientEngagementMessageLevelOrderByRelevanceFieldEnum = {
  level: 'level',
  name: 'name'
};

exports.Prisma.PatientEngagementMessageOrderByRelevanceFieldEnum = {
  message_en: 'message_en',
  message_he: 'message_he'
};

exports.Prisma.PatientGoalOrderByRelevanceFieldEnum = {
  title: 'title',
  img_url: 'img_url',
  description: 'description'
};

exports.Prisma.CarePlanOrderByRelevanceFieldEnum = {
  title: 'title',
  description: 'description'
};

exports.Prisma.ChatPreferenceOrderByRelevanceFieldEnum = {
  sid: 'sid',
  type: 'type'
};

exports.Prisma.TaskAttachmentOrderByRelevanceFieldEnum = {
  key: 'key',
  entity: 'entity',
  original_name: 'original_name'
};

exports.Prisma.DisabledFeaturesOrderByRelevanceFieldEnum = {
  type: 'type'
};

exports.Prisma.DataMigrationsOrderByRelevanceFieldEnum = {
  migration_name: 'migration_name'
};

exports.Prisma.ScreeningTemplateOrderByRelevanceFieldEnum = {
  url_indentifier: 'url_indentifier',
  company_logo_url: 'company_logo_url',
  company_title: 'company_title',
  welcome_title: 'welcome_title',
  welcome_subtitle: 'welcome_subtitle',
  seo_title: 'seo_title',
  final_title: 'final_title',
  final_subtitle: 'final_subtitle',
  contact_phone_number: 'contact_phone_number',
  captca_info: 'captca_info'
};

exports.Prisma.ScreeningTemplateQuestionOrderByRelevanceFieldEnum = {
  question: 'question',
  description: 'description'
};

exports.Prisma.ScreeningQuestionResponseOrderByRelevanceFieldEnum = {
  value: 'value'
};

exports.Prisma.ScreeningAnswerOrderByRelevanceFieldEnum = {
  value: 'value'
};

exports.Prisma.CandidateUserOrderByRelevanceFieldEnum = {
  uuid: 'uuid',
  summary: 'summary',
  rejection_reason: 'rejection_reason',
  rejection_reason_details: 'rejection_reason_details',
  email: 'email',
  phone: 'phone',
  first_name: 'first_name',
  last_name: 'last_name',
  address: 'address'
};

exports.Prisma.IntakeOrderByRelevanceFieldEnum = {
  summary: 'summary'
};

exports.Prisma.ScreeningInstanceOrderByRelevanceFieldEnum = {
  comments: 'comments'
};

exports.Prisma.ScreeningScaleCutoffOrderByRelevanceFieldEnum = {
  name: 'name',
  color: 'color'
};

exports.Prisma.ScreeningQuestionScaleOrderByRelevanceFieldEnum = {
  name: 'name',
  guideline: 'guideline',
  color: 'color'
};

exports.Prisma.ScreeningQuestionScaleCutoffOrderByRelevanceFieldEnum = {
  name: 'name',
  color: 'color'
};

exports.Prisma.UnitChapterOrderByRelevanceFieldEnum = {
  name: 'name',
  description: 'description'
};

exports.Prisma.MediaObjectOrderByRelevanceFieldEnum = {
  original_file_name: 'original_file_name',
  original_file_type: 'original_file_type',
  saved_file_name: 'saved_file_name',
  saved_file_path: 'saved_file_path',
  upload_result_string: 'upload_result_string',
  thumbnail_ref: 'thumbnail_ref'
};

exports.Prisma.WebBasedEventOrderByRelevanceFieldEnum = {
  link_uuid: 'link_uuid'
};
exports.OrgRole = exports.$Enums.OrgRole = {
  admin: 'admin',
  caregiver: 'caregiver',
  external_therapist: 'external_therapist'
};

exports.Specialty = exports.$Enums.Specialty = {
  clinical_psychology: 'clinical_psychology',
  organizational_psychology: 'organizational_psychology',
  medical_psychology: 'medical_psychology',
  developmental_psychology: 'developmental_psychology',
  rehabilitation_psychology: 'rehabilitation_psychology',
  educational_psychology: 'educational_psychology',
  sport_psychology: 'sport_psychology',
  social_psychology: 'social_psychology'
};

exports.Profession = exports.$Enums.Profession = {
  psychologist: 'psychologist',
  psychiatrist: 'psychiatrist',
  psychotherapist: 'psychotherapist',
  speech_therapist: 'speech_therapist',
  occupational_therapist: 'occupational_therapist',
  coach: 'coach',
  dietitian: 'dietitian',
  social_worker: 'social_worker',
  therapist: 'therapist',
  Counselor: 'Counselor',
  family_therapist: 'family_therapist',
  nurse_psychotherapist: 'nurse_psychotherapist',
  drama_therapist: 'drama_therapist',
  art_therapist: 'art_therapist',
  child_adolescent_sychiatrist: 'child_adolescent_sychiatrist',
  clinical_director: 'clinical_director',
  physician: 'physician',
  nurse_practitioner: 'nurse_practitioner',
  meditation_clinician: 'meditation_clinician',
  other: 'other'
};

exports.TreatmentEndReason = exports.$Enums.TreatmentEndReason = {
  goals_accomplished: 'goals_accomplished',
  patient_decision: 'patient_decision',
  dropout: 'dropout',
  technical_issues: 'technical_issues'
};

exports.Language = exports.$Enums.Language = {
  he: 'he',
  en: 'en'
};

exports.WeekStart = exports.$Enums.WeekStart = {
  sun: 'sun',
  mon: 'mon'
};

exports.UserRole = exports.$Enums.UserRole = {
  admin: 'admin',
  therapist: 'therapist',
  patient: 'patient',
  significant_other: 'significant_other'
};

exports.Gender = exports.$Enums.Gender = {
  male: 'male',
  female: 'female',
  non_binary: 'non_binary',
  transgender: 'transgender',
  intersex: 'intersex',
  other: 'other',
  all: 'all'
};

exports.OsType = exports.$Enums.OsType = {
  android: 'android',
  ios: 'ios'
};

exports.RelationType = exports.$Enums.RelationType = {
  parent: 'parent',
  sibling: 'sibling',
  spouse: 'spouse',
  child: 'child',
  friend: 'friend',
  other: 'other'
};

exports.CollaboratorRole = exports.$Enums.CollaboratorRole = {
  therapist: 'therapist',
  external: 'external',
  family: 'family'
};

exports.Permission = exports.$Enums.Permission = {
  limited: 'limited',
  view: 'view',
  comment: 'comment',
  crud: 'crud',
  case_manager: 'case_manager'
};

exports.QuestionType = exports.$Enums.QuestionType = {
  free_text: 'free_text',
  select: 'select',
  multiple_choice: 'multiple_choice',
  number: 'number',
  percent: 'percent',
  minutes: 'minutes',
  time_of_day: 'time_of_day',
  guideline: 'guideline',
  scale: 'scale',
  scale_slider: 'scale_slider',
  scale_reverse: 'scale_reverse',
  yes_no: 'yes_no'
};

exports.CareProtocolAssignedStatus = exports.$Enums.CareProtocolAssignedStatus = {
  ACTIVE: 'ACTIVE',
  COMPLETE: 'COMPLETE',
  PARTIALLY_COMPLETE: 'PARTIALLY_COMPLETE'
};

exports.ScaleDirection = exports.$Enums.ScaleDirection = {
  positive: 'positive',
  negative: 'negative'
};

exports.ScaleCalculation = exports.$Enums.ScaleCalculation = {
  avg: 'avg',
  sum: 'sum'
};

exports.MoreOrLess = exports.$Enums.MoreOrLess = {
  more: 'more',
  less: 'less'
};

exports.EventType = exports.$Enums.EventType = {
  educational_content: 'educational_content',
  questionnaire: 'questionnaire',
  task: 'task',
  appointment: 'appointment',
  reflection: 'reflection',
  mood: 'mood',
  exercise: 'exercise',
  tracker: 'tracker',
  unit: 'unit'
};

exports.EventStatus = exports.$Enums.EventStatus = {
  archived: 'archived',
  deleted: 'deleted',
  pending: 'pending',
  rejected: 'rejected',
  approved: 'approved'
};

exports.TimeUnit = exports.$Enums.TimeUnit = {
  week: 'week',
  day: 'day',
  hour: 'hour'
};

exports.TaskStatus = exports.$Enums.TaskStatus = {
  completed: 'completed',
  declined: 'declined',
  partial: 'partial',
  discussion_point: 'discussion_point'
};

exports.AppointmentStatus = exports.$Enums.AppointmentStatus = {
  occured: 'occured',
  not_showed: 'not_showed',
  canceled: 'canceled'
};

exports.MoodStatus = exports.$Enums.MoodStatus = {
  angry: 'angry',
  anxious: 'anxious',
  sad: 'sad',
  overwhelmed: 'overwhelmed',
  relaxed: 'relaxed',
  happy: 'happy',
  proud: 'proud'
};

exports.LibraryTemplateType = exports.$Enums.LibraryTemplateType = {
  EXERCISE: 'EXERCISE',
  EDUCATIONAL_CONTENT: 'EDUCATIONAL_CONTENT',
  UNIT: 'UNIT',
  CARE_PROTOCOL: 'CARE_PROTOCOL'
};

exports.ExerciseType = exports.$Enums.ExerciseType = {
  EXERCISE_ONLY: 'EXERCISE_ONLY',
  EXERCISE_JOURNAL: 'EXERCISE_JOURNAL'
};

exports.PreviousInstance = exports.$Enums.PreviousInstance = {
  CURRENT_ANSWERS_ONLY: 'CURRENT_ANSWERS_ONLY',
  PREVIOUS_ANSWERS: 'PREVIOUS_ANSWERS'
};

exports.ExerciseStatuses = exports.$Enums.ExerciseStatuses = {
  INIT: 'INIT',
  PUBLISHED: 'PUBLISHED',
  ACTIVE: 'ACTIVE',
  ARCHIVED: 'ARCHIVED',
  DELETED: 'DELETED'
};

exports.ExerciseQuestionType = exports.$Enums.ExerciseQuestionType = {
  scale: 'scale',
  yes_no: 'yes_no',
  free_text: 'free_text',
  multiple_choice: 'multiple_choice',
  minutes: 'minutes',
  select: 'select',
  number: 'number',
  percent: 'percent',
  time_of_day: 'time_of_day',
  image: 'image',
  text: 'text',
  multi_chip: 'multi_chip'
};

exports.TrackerTranslationType = exports.$Enums.TrackerTranslationType = {
  group: 'group',
  measure: 'measure',
  question: 'question',
  label: 'label'
};

exports.NotificationStatus = exports.$Enums.NotificationStatus = {
  CREATED: 'CREATED',
  SCHEDULED: 'SCHEDULED',
  SENT: 'SENT',
  FAILED: 'FAILED'
};

exports.PatientEngagementState = exports.$Enums.PatientEngagementState = {
  FULL_COMPLETE: 'FULL_COMPLETE',
  PARTIAL_COMPLETE: 'PARTIAL_COMPLETE',
  NO_COMPLETE: 'NO_COMPLETE',
  UNRESPONSIVE: 'UNRESPONSIVE',
  NO_EVENTS: 'NO_EVENTS'
};

exports.GoalType = exports.$Enums.GoalType = {
  awareness: 'awareness',
  activity: 'activity',
  persistency: 'persistency'
};

exports.ScreeningStatusType = exports.$Enums.ScreeningStatusType = {
  INIT: 'INIT',
  ACTIVE: 'ACTIVE',
  ARCHIVED: 'ARCHIVED',
  DELETED: 'DELETED'
};

exports.ScreeningTemplateType = exports.$Enums.ScreeningTemplateType = {
  FIRST_SCREENING: 'FIRST_SCREENING',
  SECOND_SCREENING: 'SECOND_SCREENING'
};

exports.ScreeningQuestionsListType = exports.$Enums.ScreeningQuestionsListType = {
  PERSONAL_DETAILS: 'PERSONAL_DETAILS',
  SCREENING_QUESTIONS: 'SCREENING_QUESTIONS'
};

exports.ScreeningQuestionType = exports.$Enums.ScreeningQuestionType = {
  free_text: 'free_text',
  select: 'select',
  multiple_choice: 'multiple_choice',
  number: 'number',
  percent: 'percent',
  minutes: 'minutes',
  time_of_day: 'time_of_day',
  guideline: 'guideline',
  scale: 'scale',
  scale_slider: 'scale_slider',
  scale_reverse: 'scale_reverse',
  yes_no: 'yes_no',
  image: 'image',
  text_only: 'text_only',
  questionnaire: 'questionnaire'
};

exports.ColumnName = exports.$Enums.ColumnName = {
  email: 'email',
  phone: 'phone',
  first_name: 'first_name',
  last_name: 'last_name',
  gender: 'gender',
  date_of_birth: 'date_of_birth',
  address: 'address'
};

exports.ScreeningStatus = exports.$Enums.ScreeningStatus = {
  INITIAL: 'INITIAL',
  INTAKE: 'INTAKE',
  REJECTED: 'REJECTED',
  ACCEPTED: 'ACCEPTED'
};

exports.UnitChapterElementType = exports.$Enums.UnitChapterElementType = {
  EXERCISE: 'EXERCISE',
  EDUCATIONAL_CONTENT: 'EDUCATIONAL_CONTENT',
  QUESTIONNAIRE: 'QUESTIONNAIRE'
};

exports.OwnerObjectType = exports.$Enums.OwnerObjectType = {
  USER: 'USER',
  QUESTIONNAIRE: 'QUESTIONNAIRE',
  EDUCATIONAL_CONTENT: 'EDUCATIONAL_CONTENT',
  EXERCISE: 'EXERCISE'
};

exports.MediaType = exports.$Enums.MediaType = {
  IMAGE: 'IMAGE',
  AUDIO: 'AUDIO',
  VIDEO: 'VIDEO',
  FILE: 'FILE',
  PDF: 'PDF'
};

exports.MediaStatus = exports.$Enums.MediaStatus = {
  INIT: 'INIT',
  UPLOADING: 'UPLOADING',
  SAVED: 'SAVED',
  DELETED: 'DELETED',
  ACTIVE: 'ACTIVE'
};

exports.StorageProvider = exports.$Enums.StorageProvider = {
  AWS_S3: 'AWS_S3',
  CLOUDINARY: 'CLOUDINARY'
};

exports.ElementType = exports.$Enums.ElementType = {
  UNIT: 'UNIT',
  EXERCISE: 'EXERCISE',
  QUESTIONNAIRE: 'QUESTIONNAIRE'
};

exports.TriggerType = exports.$Enums.TriggerType = {
  SEQUENTIAL_MANUAL: 'SEQUENTIAL_MANUAL',
  SEQUENTIAL_TRIGGERED: 'SEQUENTIAL_TRIGGERED',
  SCHEDULED: 'SCHEDULED'
};

exports.TriggeringLogic = exports.$Enums.TriggeringLogic = {
  PREVIOUS: 'PREVIOUS',
  COMPLEX: 'COMPLEX'
};

exports.SequentialEventStatuses = exports.$Enums.SequentialEventStatuses = {
  INIT: 'INIT',
  TRIGGERED: 'TRIGGERED',
  AVALIABLE: 'AVALIABLE',
  COMPLETED: 'COMPLETED',
  SKIPPED: 'SKIPPED'
};

exports.Prisma.ModelName = {
  Organization: 'Organization',
  TeamMember: 'TeamMember',
  PatientFile: 'PatientFile',
  Tag: 'Tag',
  UserPreferences: 'UserPreferences',
  User: 'User',
  AppLog: 'AppLog',
  ApprovedTerms: 'ApprovedTerms',
  PatientToFamilyUser: 'PatientToFamilyUser',
  Collaborator: 'Collaborator',
  CollaboratorPermission: 'CollaboratorPermission',
  Question: 'Question',
  QuestionnaireDef: 'QuestionnaireDef',
  CarePlanProtocolAssignment: 'CarePlanProtocolAssignment',
  Diagnosis: 'Diagnosis',
  QuestionnaireDraft: 'QuestionnaireDraft',
  QuestionnaireScale: 'QuestionnaireScale',
  QuestionnaireScaleCutoff: 'QuestionnaireScaleCutoff',
  QuestionScale: 'QuestionScale',
  QuestionScaleCutoff: 'QuestionScaleCutoff',
  QuestionResponse: 'QuestionResponse',
  QuestionGroupScore: 'QuestionGroupScore',
  QuestionAlert: 'QuestionAlert',
  Event: 'Event',
  UnitEventsToChapter: 'UnitEventsToChapter',
  UnitEvent: 'UnitEvent',
  EventRecurrence: 'EventRecurrence',
  EventComment: 'EventComment',
  EventCondition: 'EventCondition',
  TaskEvent: 'TaskEvent',
  TaskDef: 'TaskDef',
  QuestionnaireEvent: 'QuestionnaireEvent',
  AppointmentEvent: 'AppointmentEvent',
  MoodEvent: 'MoodEvent',
  ReflectionThoughts: 'ReflectionThoughts',
  ExerciseEvent: 'ExerciseEvent',
  EducationalContentEvent: 'EducationalContentEvent',
  PatientToJournal: 'PatientToJournal',
  DiagnosesOnLibraryTemplate: 'DiagnosesOnLibraryTemplate',
  RolesOnLibraryTemplate: 'RolesOnLibraryTemplate',
  LibraryTemplate: 'LibraryTemplate',
  EducationalContent: 'EducationalContent',
  Roles: 'Roles',
  ExerciseQuestion: 'ExerciseQuestion',
  ExerciseResponse: 'ExerciseResponse',
  TrackerEvent: 'TrackerEvent',
  TrackerQuestion: 'TrackerQuestion',
  TrackerDefinition: 'TrackerDefinition',
  TrackerResponse: 'TrackerResponse',
  TrackerQuestionLabel: 'TrackerQuestionLabel',
  TrackerTranslation: 'TrackerTranslation',
  PortalNotification: 'PortalNotification',
  MobileNotification: 'MobileNotification',
  EmailNotification: 'EmailNotification',
  PatientEngagementSnapshot: 'PatientEngagementSnapshot',
  PatientEngagementMessageLevel: 'PatientEngagementMessageLevel',
  PatientEngagementMessage: 'PatientEngagementMessage',
  PatientGoal: 'PatientGoal',
  PatientPointLog: 'PatientPointLog',
  CarePlan: 'CarePlan',
  QuestionnairesOnCarePlan: 'QuestionnairesOnCarePlan',
  CarePlanToLibraryTemplate: 'CarePlanToLibraryTemplate',
  CarePlanToTask: 'CarePlanToTask',
  ChatPreference: 'ChatPreference',
  TaskAttachment: 'TaskAttachment',
  DisabledFeatures: 'DisabledFeatures',
  DataMigrations: 'DataMigrations',
  ScreeningTemplate: 'ScreeningTemplate',
  ScreeningTemplateQuestion: 'ScreeningTemplateQuestion',
  ScreeningGroupScore: 'ScreeningGroupScore',
  ScreeningQuestionResponse: 'ScreeningQuestionResponse',
  ScreeningAnswer: 'ScreeningAnswer',
  CandidateUser: 'CandidateUser',
  Intake: 'Intake',
  ScreeningInstance: 'ScreeningInstance',
  ScreeningScale: 'ScreeningScale',
  ScreeningScaleCutoff: 'ScreeningScaleCutoff',
  ScreeningQuestionScale: 'ScreeningQuestionScale',
  ScreeningQuestionScaleCutoff: 'ScreeningQuestionScaleCutoff',
  UnitChapter: 'UnitChapter',
  UnitChapterElement: 'UnitChapterElement',
  MediaObject: 'MediaObject',
  CareProtocolElement: 'CareProtocolElement',
  CareProtocolSequentialEvents: 'CareProtocolSequentialEvents',
  WebBasedEvent: 'WebBasedEvent'
};

/**
 * This is a stub Prisma Client that will error at runtime if called.
 */
class PrismaClient {
  constructor() {
    return new Proxy(this, {
      get(target, prop) {
        let message
        const runtime = getRuntime()
        if (runtime.isEdge) {
          message = `PrismaClient is not configured to run in ${runtime.prettyName}. In order to run Prisma Client on edge runtime, either:
- Use Prisma Accelerate: https://pris.ly/d/accelerate
- Use Driver Adapters: https://pris.ly/d/driver-adapters
`;
        } else {
          message = 'PrismaClient is unable to run in this browser environment, or has been bundled for the browser (running in `' + runtime.prettyName + '`).'
        }
        
        message += `
If this is unexpected, please open an issue: https://pris.ly/prisma-prisma-bug-report`

        throw new Error(message)
      }
    })
  }
}

exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
